// app/frontend/entrypoints/application.js
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from '../router'
import App from '../components/App.vue'
import i18n from '../plugins/i18n'
import { useLocaleStore } from '../stores/locale'
import '../styles/application.css'
import 'flag-icons/css/flag-icons.min.css'

// Import axios configuration
import '../plugins/axios'

const app = createApp(App)
const pinia = createPinia()

app.use(pinia)
app.use(i18n)

// Resolve locale from localStorage/browser before the first render
useLocaleStore().init()

app.use(router)

// Auth is checked by the router guard before each navigation.
// The Rails-rendered auth pages (password reset) share this layout but have no #app root —
// mounting unconditionally would only log a warning on a page the user is looking at.
if (document.querySelector('#app')) {
  app.mount('#app')
}